import { Injectable } from "@angular/core";
import { ReconcilationReportCols } from "../../constants/constants";
import { ReconciliationReportSuggestionDataService } from "./reconciliation-report-suggestion-data.service";
import { v4 as uuidv4 } from "uuid";

@Injectable({
    providedIn: "root",
})
export class ReconciliationReportSearchService {
    constructor(private suggestionDataService: ReconciliationReportSuggestionDataService) {}

    search(field: string, value: string): any[] {
        if (!field) {
            return [];
        }
        if (!value) {
            return [];
        }

        let filteredData: any[] = [];
        this.suggestionDataService.data$.subscribe((data) => {
            filteredData = data.filter((item) => {
                if (field === "amount" || field === "balance") {
                    if(item[field] && value) {
                        return String(item[field])?.includes(String(value));
                    }
                } else {
                    return item[field]?.toLowerCase().includes(value.toLowerCase());
                }
            });
            filteredData = this.extractDistinctData(filteredData, field);
        });
        return filteredData;
    }

    private extractDistinctData(data: any[], field: string): any[] {
        const distinctData = new Set<string>();
        const result: any[] = [];

        data.forEach((item) => {
            const fieldValue = item[field];
            if (!distinctData.has(fieldValue)) {
                if (fieldValue && fieldValue != "") {
                    distinctData.add(fieldValue);
                    result.push({
                        id: uuidv4(),
                        name: fieldValue,
                    });
                }
            }
        });
        return result;
    }
}
